import { render, staticRenderFns } from "./dialog-tongzhuren-list.vue?vue&type=template&id=2e6f50c4&scoped=true&"
import script from "./dialog-tongzhuren-list.vue?vue&type=script&lang=js&"
export * from "./dialog-tongzhuren-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f50c4",
  null
  
)

export default component.exports